import { render, staticRenderFns } from "./SetupPlan.vue?vue&type=template&id=42880e02&scoped=true"
import script from "./SetupPlan.vue?vue&type=script&lang=js"
export * from "./SetupPlan.vue?vue&type=script&lang=js"
import style0 from "./SetupPlan.vue?vue&type=style&index=0&id=42880e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42880e02",
  null
  
)

export default component.exports